export const initialTtsSettings = {
  pitch: 1,
  rate: 1,
  volume: 0,
}
